import React, { Component } from 'react'
import classnames from 'classnames';
import Input from './shared/Input';
import Button from './shared/Button';
import { Link } from "react-router-dom";

import baseStyles from 'custom/base.styl';
import profileApi from "../api/auth";
import validate from "../utils/validate";
import { isEmpty } from "lodash";

import checkIcon from 'custom/checkIconType2';

class NewPasswordSuccess extends Component {

  render() {
    return (
      <div className={classnames(baseStyles.animate_form)}>
        <div className={baseStyles.header} key="registration-success-header">
          <h2 className={baseStyles.title_middle}>New password sent</h2>
        </div>
        <div className={classnames(baseStyles.content_board, baseStyles.centered)} key="registration-success-content">
          {/* <img className={baseStyles.content_board__icon} src={check} alt="" width="72px" /> */}
          {checkIcon()}
          <p className={classnames(baseStyles.title_extra_small, baseStyles.mb_20)}>Check your email<br />for personal temporary password</p>
          <Link to='/login'>Go to Login page</Link>
        </div>
      </div>
    )
  }
}


export default class PageRestorePassword extends Component {
  constructor(props) {
    super(props)

    this._handleOnChange = this._handleOnChange.bind(this)
    this._handleSubmit = this._handleSubmit.bind(this)

    this.state = {
      email: '',
      error: [],
      fieldError: {},
      isUpdating: false,
    }
  }

  _handleOnChange(e) {
    const { name, value } = e.target

    this.setState({
      [name]: value.trim()
    });
  }

  _handleSubmit(e) {
    e.preventDefault()
    const isValid = this._handleValidate()

    if (!isValid) {
      return false
    }

    this.setState({ isUpdating: true });

    const { email } = this.state

    const data = {
      user: {
        email: email
      }
    }

    profileApi.restorePass(data).then(() =>
      this.setState({
        sent: true
      })
    ).catch(data => {
      this.setState({ isUpdating: false });
      if (data.errors) {
        this.setState({
          sent: true
        })
      }
    });
  }

  _handleValidate() {
    const { email } = this.state

    const validateFields = [
      { name: 'email', value: email, validators: ['isRequired', 'isEmail'] },
    ]

    const fieldError = validate(validateFields)

    this.setState({
      fieldError: fieldError
    })

    return isEmpty(fieldError)
  }

  render() {
    const { email, fieldError, sent, isUpdating } = this.state
    const disabled = !email || isUpdating;

    if (sent) {
      return <NewPasswordSuccess />
    }

    return (
      <div className={baseStyles.animate_form}>
        <div className={baseStyles.content} key='password-recovery-intro'>
          <h2 className={baseStyles.title_middle}>Restore password</h2>
          <p className={baseStyles.subtitle}>Please enter your email linked to application account</p>
        </div>

        <div className={baseStyles.form_styles} key='password-recovery-form'>
          <form onSubmit={this._handleSubmit} method="post">
            <div className={baseStyles.form_field}>
              <h4 className={baseStyles.form_label}>Your email</h4>
              <Input name="email" placeholder="Enter your email" block
                onChange={this._handleOnChange} value={email}
                className={classnames({ [baseStyles.error]: fieldError.email })}
              />
              {fieldError.email && <h4 className={baseStyles.form_label_error}>{fieldError.email}</h4>}
            </div>

            <div className={baseStyles.form_field}>
              <Button type="submit" disabled={disabled} block>Restore password</Button>
            </div>
          </form>

          <div className={baseStyles.form_links}>
            <Link to='/login'>Back to Login</Link>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PageRestorePassword.js